import React, { useEffect } from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { numToLetter } from '~/commons/helpers';

const FieldsSingleSelect = ({
  qtnIndex: i,
  restrictEdit = false,
  fileUploadUrl,
}) => {
  const [, { value }] = useField(`questions.${i}`);
  const [,, { setValue: setAns }] = useField(`questions.${i}.answer`);
  const { t } = useTranslation();
  const { answer } = value;
  let { choices } = value;

  // Ensure choices is an array and handle mixed formats
  if (!Array.isArray(choices)) {
    choices = [];
  }

  // Filter out empty choices for restrictEdit mode
  if (!restrictEdit && choices.length > 0) {
    const lastChoice = choices[choices.length - 1];
    if ((typeof lastChoice === 'string' && !lastChoice.trim())
        || (typeof lastChoice === 'object' && (!lastChoice.text || !lastChoice.text.trim()))) {
      choices = choices.slice(0, -1);
    }
  }

  useEffect(() => {
    if (answer >= choices.length) {
      setAns(null);
    }
  }, [choices.length]);

  return (
    <>
      <label>{t('Choices')} *</label>
      <FieldArrayIterables
        name={`questions.${i}.choices`}
        {...restrictEdit ? {} : {
          tail: { text: '', img: '' }, // Default structure for new choices
        }}
      >
        {(c, ii) => {
          // All choices are now normalized to object format in admin interface
          const choiceText = c.text || '';
          const choiceImg = c.img || '';
          const hasText = typeof choiceText === 'string' && choiceText.trim();
          const hasImg = typeof choiceImg === 'string' && choiceImg.trim();
          return (
            <div className="form-row align-items-start mb-3" key={ii}>
              <div className="col-auto pt-2">
                {numToLetter(ii, true)}.
              </div>
              <div className="col">
                {/* Choice Text Input */}
                <FormGroup
                  radio={{
                    name: `questions.${i}.answer`,
                    value: ii.toString(),
                    disabled: ii >= choices.length || (!hasText && !hasImg),
                  }}
                  name={`questions.${i}.choices.${ii}.text`}
                  label="Choice Text"
                  placeholder={hasImg ? 'Enter choice text (optional)' : 'Enter choice text...'}
                />

                {/* Image Upload */}
                <FormGroup
                  as="coverImg"
                  api={fileUploadUrl}
                  name={`questions.${i}.choices.${ii}.img`}
                  label="Choice Image (optional)"
                  className="mt-2"
                />

                {/* No need for image preview as coverImg component handles it */}
              </div>
            </div>
          );
        }}
      </FieldArrayIterables>
    </>
  );
};

export default FieldsSingleSelect;
